import { Box, Typography, Grid, Divider } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function ServicesOverview() {
  const { t } = useTranslation("heropage");

  const primaryServices = t("services.primary", { returnObjects: true });
  const supportingServices = t("services.supporting", { returnObjects: true });

  return (
    <Box
      sx={{
        px: { xs: 3, md: 12 },
        py: { xs: 12, md: 20 },
        backgroundColor: "#F6F5F3",
      }}
    >
      {/* Editorial Header */}
      <Box sx={{ maxWidth: 880, mb: 14 }}>
        <Typography
          sx={{
            fontFamily: "Playfair Display",
            fontSize: { xs: "2.4rem", md: "3.4rem" },
            lineHeight: 1.2,
            mb: 4,
          }}
        >
          {t("services.header.title")}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: "1.05rem",
            lineHeight: 2,
            color: "#444",
          }}
        >
          {t("services.header.description")}
        </Typography>
      </Box>

      {/* Primary Services */}
      <Grid container spacing={8}>
        {primaryServices.map((service, index) => (
          <Grid item xs={12} md={6} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: index * 0.1 }}
            >
              <Box
                sx={{
                  p: { xs: 4, md: 6 },
                  backgroundColor: "#FFFFFF",
                  borderRadius: "18px",
                  boxShadow: "0 30px 70px rgba(0,0,0,0.07)",
                  height: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Playfair Display",
                    fontSize: "1.6rem",
                    mb: 3,
                  }}
                >
                  {service.title}
                </Typography>

                {service.body.map((paragraph, i) => (
                  <Typography
                    key={i}
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "0.98rem",
                      lineHeight: 1.9,
                      color: "#555",
                      mb: i !== service.body.length - 1 ? 3 : 0,
                    }}
                  >
                    {paragraph}
                  </Typography>
                ))}
              </Box>
            </motion.div>
          </Grid>
        ))}
      </Grid>

      {/* Supporting Capabilities */}
      <Box sx={{ mt: 16 }}>
        <Divider sx={{ mb: 6 }} />

        <Typography
          sx={{
            fontFamily: "Playfair Display",
            fontSize: "1.8rem",
            mb: 4,
          }}
        >
          {t("services.supportingTitle")}
        </Typography>

        <Grid container spacing={3}>
          {supportingServices.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "0.9rem",
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  color: "#666",
                }}
              >
                {item}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
